module.exports = __webpack_public_path__ + "static/media/gameplay-1.12ecbed9.png";